export default __webpack_public_path__ + "static/media/soeren.d91b4342.jpg";